import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d396f524"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-items-select-navigation-container" }
const _hoisted_2 = { class: "select-container" }

import ListItemsSelect from "@/components/select/ListItemsSelect/ListItemsSelect.vue";
import MobileNavigationBar from "@/components/layouts/MobileNavigationBar/MobileNavigationBar.vue";
import { IListItemsArray } from "@/types/list";

interface Props {
  disableTitleTranslation?: boolean;
  listsArray: IListItemsArray[];
  navigationTitle: string;
  handleRedirect?: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemsSelectNavigationContainer',
  props: {
    disableTitleTranslation: { type: Boolean, default: false },
    listsArray: { default: () => [] },
    navigationTitle: { default: "" },
    handleRedirect: { type: Function, default: undefined }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MobileNavigationBar, {
      title: _ctx.navigationTitle,
      "handle-redirect": _ctx.handleRedirect
    }, null, 8, ["title", "handle-redirect"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listsArray, (array, index) => {
        return (_openBlock(), _createBlock(ListItemsSelect, {
          key: index,
          "list-items-array": array
        }, null, 8, ["list-items-array"]))
      }), 128))
    ])
  ]))
}
}

})